import { render, staticRenderFns } from "./ShadowCard.vue?vue&type=template&id=158362b0&scoped=true&"
import script from "./ShadowCard.vue?vue&type=script&lang=js&"
export * from "./ShadowCard.vue?vue&type=script&lang=js&"
import style0 from "./ShadowCard.vue?vue&type=style&index=0&id=158362b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158362b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('158362b0')) {
      api.createRecord('158362b0', component.options)
    } else {
      api.reload('158362b0', component.options)
    }
    module.hot.accept("./ShadowCard.vue?vue&type=template&id=158362b0&scoped=true&", function () {
      api.rerender('158362b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/ShadowCard.vue"
export default component.exports